import TextField from '@material-ui/core/TextField';
import {withStyles} from '@material-ui/core/styles/index';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions'
import queryString from 'query-string';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

require('../../../bootstrap');

import React, {PureComponent} from 'react';
import {loginWithCredentials, loginWithToken, sendAuthPinCode, sendPassword} from "../../api";
import Loader from "../Simple/Loader";
import Credentials from "./Credentials";
import SendPassword from "./SendPassword";
import AuthPinCode from "./AuthPinCode";

const styles = theme => ({
    card: {
        margin: theme.spacing(1),
        maxWidth: 400,
        padding: theme.spacing(1),
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        width: '100%',
    },
    dense: {
        marginTop: 16,
    },
    menu: {
        width: 200,
    },
    button: {
        margin: theme.spacing(1),
    },
    imageWrapper: {
        textAlign: 'center',
        padding: theme.spacing(8),
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(2),
    },
    image: {
        maxWidth: '100%',
    },
    loadingSpinner: {
        color: theme.palette.primary[500],
        marginRight: theme.spacing(1),
    },
    loginTypeButton: {
        width: 280,
        marginLeft: 0,
        marginRight: 0,
        maxWidth: '100%'
    },
    description: {
        marginBottom: theme.spacing(2),
    },
});

class LoginForm extends PureComponent {
    state = {
        loginType: null,
        email: '',
        password: '',
        sentPassword: '',
        ssn: '',
        pinCode: '',
        pinCodeToken: null,
        loading: true,
        loginErrorMessage: null,
        authPinCodeErrorMessage: null,
        sentPasswordErrorMessage: null,
        passwordSendLoading: false,
        passwordSentSuccessful: false,
    }

    componentDidMount() {
        const parsedQueryString = queryString.parse(window.location.search);
        let pinCodeToken = parsedQueryString['pct']
        if (pinCodeToken) {
            this.setState({'pinCodeToken': pinCodeToken, loginType: 'authPinCode', loading: false})
            return;
        }

        loginWithToken().then(res => {
                this.setState({loading: false})
                this.props.success()
            }
        ).catch(err => {
            this.setState({loading: false})
        });
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    postLogin = () => {
        this.setState({loginErrorMessage: null})
        loginWithCredentials(this.state.email, this.state.password)
            .then(res => {
                    this.props.success()
                }
            ).catch(err => {
            this.setState({loginErrorMessage: 'Kirjautuminen epäonnistui. Tarkista tiedot.'})
        });
    }

    postSendPassword = () => {
        this.setState({sendPasswordMessage: null, passwordSendLoading: true})
        sendPassword(this.state.ssn)
            .then(res => {
                    this.setState({
                        sendPasswordMessage: 'Salasana on lähetetty sähköpostiisi.',
                        email: res.data.email,
                        passwordSendLoading: false,
                        passwordSentSuccessful: true
                    })
                }
            ).catch(err => {
            this.setState({sendPasswordMessage: 'Virhe. Tarkista henkilötunnus.', passwordSendLoading: false})
        });
    }

    postSentPasswordLogin = () => {
        this.setState({sentPasswordErrorMessage: null})
        loginWithCredentials(this.state.email, this.state.sentPassword)
            .then(res => {
                    this.props.success()
                }
            ).catch(err => {
            this.setState({sentPasswordErrorMessage: 'Kirjautuminen epäonnistui. Tarkista tiedot.'})
        });
    }

    changeLoginType = (loginType) => {
        this.setState({loginType: loginType})
    }

    onLoginWithBankIdentification = () => {
        location = '/login/secure';
    }

    postSendAuthPinCode = () => {
        this.setState({authPinCodeErrorMessage: null})
        sendAuthPinCode(this.state.pinCode, this.state.pinCodeToken)
            .then(res => {
                    location = '/'
                }
            ).catch(err => {
            this.setState({authPinCodeErrorMessage: 'Kirjautuminen epäonnistui. Tarkista koodi.'})
        });
    }

    render() {
        const {loginType, email, password, ssn, loading, loginErrorMessage, sendPasswordMessage, authPinCodeErrorMessage, sentPasswordErrorMessage, passwordSendLoading, passwordSentSuccessful} = this.state
        const {classes} = this.props

        return (
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
                style={{minHeight: '100vh'}}
            >
                {loading && <Grid item xs={12} sm={8} md={6} lg={4}>
                    <div className="loader-wrapper my-2">
                        <Loader/>
                    </div>
                </Grid>}

                {!loading && <Grid item xs={12} sm={8} md={6} lg={4}>
                    <Card className={classes.card}>
                        <div className={classes.imageWrapper}>
                            <img src="/img/logo-tarjous@2x.png" className={classes.image}/>
                        </div>
                        {loginType === null &&
                        <CardContent>
                            <Typography gutterBottom variant="body1" align="center" className={classes.description}>
                                Kirjautumisvaihtoehdot
                            </Typography>
                            <Typography align="center">
                                <Button variant="contained" color="primary"
                                        className={classes.button + ' ' + classes.loginTypeButton}
                                        onClick={this.onLoginWithBankIdentification}>
                                    Pankkitunnistautuminen
                                </Button>
                            </Typography>
                            <Typography gutterBottom align="center">
                                <Button variant="contained" color="primary"
                                        className={classes.button + ' ' + classes.loginTypeButton}
                                        onClick={() => this.changeLoginType('sendPassword')}>
                                    Sähköposti
                                </Button>
                            </Typography>
                            <Typography align="center">
                                <Button color="primary"
                                        className={classes.button + ' ' + classes.loginTypeButton}
                                        onClick={() => this.changeLoginType('credentials')}>
                                    Käyttäjätunnukset
                                </Button>
                            </Typography>
                        </CardContent>
                        }
                        {loginType === 'sendPassword' && <>
                            <SendPassword postSendPassword={this.postSendPassword}
                                          postSentPasswordLogin={this.postSentPasswordLogin}
                                          ssn={ssn}
                                          passwordSendLoading={passwordSendLoading}
                                          passwordSentSuccessful={passwordSentSuccessful}
                                          sendPasswordMessage={sendPasswordMessage}
                                          sentPasswordErrorMessage={sentPasswordErrorMessage}
                                          changeLoginType={this.changeLoginType}
                                          handleChange={this.handleChange}/>
                        </>
                        }
                        {loginType === 'authPinCode' && <>
                            <AuthPinCode postSendAuthPinCode={this.postSendAuthPinCode}
                                         authPinCodeErrorMessage={authPinCodeErrorMessage}
                                         handleChange={this.handleChange}/>
                        </>
                        }
                        {loginType === 'credentials' && <>
                            <Credentials postLogin={this.postLogin} email={email}
                                         changeLoginType={this.changeLoginType}
                                         password={password}
                                         errorMessage={loginErrorMessage}
                                         handleChange={this.handleChange}/>
                            <Divider variant="middle"/>
                            <CardContent>
                                <Typography gutterBottom variant="body1" align="center">
                                    Muut kirjautumisvaihtoehdot
                                </Typography>
                                <Typography align="center">
                                    <Button variant="contained" color="primary"
                                            className={classes.button + ' ' + classes.loginTypeButton}
                                            onClick={this.onLoginWithBankIdentification}>
                                        Pankkitunnistautuminen
                                    </Button>
                                </Typography>
                                <Typography align="center">
                                    <Button variant="contained" color="primary"
                                            className={classes.button + ' ' + classes.loginTypeButton}
                                            onClick={() => this.changeLoginType('sendPassword')}>
                                        Salasana sähköpostiin
                                    </Button>
                                </Typography>
                            </CardContent>
                        </>
                        }
                    </Card>
                </Grid>}
            </Grid>
        )
    };
}

export default withStyles(styles)(LoginForm);
